import { RouteComponentProps } from 'react-router';
import { withTranslation, WithTranslation } from 'react-i18next';
import { NotificationModel, SupplierModel } from '../../../../api/admin/admin.types';
import { AppState } from '../../../../store/store.types';
import { ThunkDispatch } from 'redux-thunk';
import { ClassifierActionTypes } from '../../types/classifier.types';
import { connect } from 'react-redux';
import React from 'react';
import { Link } from 'react-router-dom';
import { getNotifications } from '../../actions/notification.actions';
import { formatDate } from '../../../../helpers/date.helper';
import { UncontrolledTooltip as Tooltip } from 'reactstrap';
import ListViewTable from '../../../../components/tables/ListViewTable';

interface NotificationProps extends RouteComponentProps, WithTranslation {
  getNotificationsList: () => void;
  notifications: NotificationModel[] | null;
  suppliers: SupplierModel[];
}

class Notifications extends React.Component<NotificationProps> {


  componentDidMount() {
    this.props.getNotificationsList();
  }

  onRowClick = (rowInfo: any) => (
    this.props.history.push(`/admin/notifications/${rowInfo.original.id}/view`)
  );

  typeCell = (props: any) => {
    return (
      <div className={props ? 'text-warning' : 'text-success'}>
        {props ? 'IMPORTANT' : 'INFORMATIVE'}
      </div>
    );
  };

  dateCell = (props: any) => {
    return (
      <div>
        {props ? formatDate(props) : ''}
      </div>
    );
  };

  supplierCell = ({ cell, row }: { cell: any, row: any }) => {
    const { t } = this.props;
    const supplierList: JSX.Element[] = [];
    if (cell.row.original.suppliers.length > 0) {
      cell.row.original.suppliers.forEach((supplierCode: any) => {
        const supplier = this.props.suppliers.find((c) => c.code === supplierCode.code);
        if (supplier) {
          supplierList.push(
            <div key={supplier.name}>
              {supplier.name}
            </div>
          );
        }
      });
    }
    if (supplierList.length === 1) {
      return supplierList[ 0 ];
    } else if (supplierList.length > 1) {
      return (
        <div>
          <div
            className="btn btn-link font-normal p-0"
            id={`supplier-tooltip-${cell.row.original.id}`}
          >
            {t('v.notifications.suppliers', { count: cell.row.original.suppliers.length })}
          </div>
          <Tooltip
            modifiers={{ preventOverflow: { boundariesElement: 'window' } }}
            placement="top"
            target={`supplier-tooltip-${cell.row.original.id}`}
            autohide={false}
          >
            <div>
              {supplierList}
            </div>
          </Tooltip>
        </div>
      );
    }
    return '';
  };

  defineColumns() {
    return [
      {
        header: 'Title', accessorKey: 'title', id: 'title'
      },
      {
        header: 'Expires after',
        accessorKey: 'expiresAfter',
        id: 'expiresAfter',
        cell: (cell: any) => this.dateCell(cell.getValue())
      },
      {
        header: 'Type',
        accessorKey: 'important',
        id: 'important',
        cell: (cell: any) => this.typeCell(cell.getValue())
      },
      {
        header: 'Suppliers',
        accessorKey: 'suppliers',
        id: 'suppliers',
        cell: ({ cell, row }: { cell: any, row: any }) => this.supplierCell({ cell, row })
      }
    ];
  }

  render() {
    const { t } = this.props;

    return (
      <main>
        <div className="page-content">
          <div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
            <h1>Notifications</h1>
            <Link
              to={{
                pathname: '/admin/notifications/create'
              }}
              className="btn btn-primary btn-wide"
            >
              {t('b.add_new').toUpperCase()}
            </Link>
          </div>
          {this.props.notifications ?
            <ListViewTable data={this.props.notifications} columns={this.defineColumns()} getTrProps={this.onRowClick}/> : null
          }
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  notifications: state.admin.notifications.notifications,
  suppliers: state.authentication.suppliers,
  totalPages: state.admin.classifiers.totalPages,
  totalElements: state.admin.classifiers.totalElements
});

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, ClassifierActionTypes>) => ({
  getNotificationsList: () => dispatch(getNotifications())
});

export default withTranslation()(connect(
  mapStateToProps,
  mapDispatchToProps
)(Notifications));